import React, {useMemo, useState} from "react";
import {maxiGet} from "../core/maxios";
import {LightContainer, MyReactTable} from "../core/input_fields";
import Status from "../core/status";
import {Loader} from "../core/components";
import {dateFormatTime} from "../core/dateFuncs";
import {Link} from "react-router-dom";

export default function ShowOffersOfPerson({event, person}) {
    const [registrations, setRegistrations] = useState([]);
    const [{error, loading, success}, setStatusVar] = useState({});
    const loadRegistration = () => maxiGet(`/registration/per_person/${event.ID}/${person.ID}`, {setStatusVar}).then(data => {
        setRegistrations(data.registrations)
    })
    useMemo(loadRegistration, []);
    const anyTeam = registrations.some(a => !!a.registered_person?.teamName);

    return <LightContainer name={"Optionen für "+(registrations.length>0?registrations[0].person.fullname:"")}>
        <Status type={"error"} text={error}/>
        <Loader loading={loading}/>
        <MyReactTable
            data={registrations}
            loading={loading}
            columns={[
                {
                    Header: "Option",
                    accessor: "offer.description",
                    filterable: true,
                },
                {
                    Header: "Art",
                    accessor: "registered_person.role.label",
                    filterable: true,
                    maxWidth: 100,
                },
                {
                    Header: "Mannschaft",
                    show: anyTeam,
                    accessor: "registered_person.teamName",
                    filterable: true,
                },
                {
                    Header: "Registrant",
                    accessor: "owner.fullname",
                    filterable: true,
                },

                {
                    Header: "Abgesendet",
                    accessor: "registration.timeFinalized",//data => data.registration.timeFinalized ? dateFormatTime(new Date(data.registration.timeFinalized)) : "nicht abgeschickt",
                    id: "timeFinalized",
                    filterable: true,
                    Cell: ({value}) => value ? dateFormatTime(new Date(value)) : "nicht abgeschickt"
                },
                {
                    Header: "",
                    maxWidth: 100,
                    Cell: ({original}) => <>
                        <Link to={"/anmeldungen/" + original.registration.ID}>anschauen</Link>
                    </>,
                }

            ]}
        />
    </LightContainer>
}
